export default __webpack_public_path__ + "static/media/ss7.9e465c16.jpg";